import { useLang } from "@/context/LanguageContext";
import { Target, ChevronRight } from "lucide-react";

export default function Admissions() {
  const { t } = useLang();

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="admissions"
      data-testid="admissions-section"
      className="py-24 sm:py-32 bg-[#111111]"
    >
      <div className="max-w-5xl mx-auto px-6">
        {/* Section Label */}
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-[2px] bg-[#FF3B30]" />
          <span className="text-xs uppercase tracking-[0.3em] text-[#A3A3A3] font-body">
            {t.admissions.label}
          </span>
        </div>

        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight text-white mb-6">
          {t.admissions.title}
        </h2>

        {/* Intro */}
        <p className="text-sm sm:text-base text-[#A3A3A3] font-body leading-relaxed max-w-3xl mb-4">
          {t.admissions.intro}
        </p>

        <p className="text-sm font-heading uppercase tracking-wider text-[#FF3B30] mb-16">
          {t.admissions.limited}
        </p>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {t.admissions.steps.map((step) => (
            <div
              key={step.number}
              data-testid={`admissions-step-${step.number}`}
              className="group bg-[#0A0A0A] border border-[#262626] p-6 hover:border-[#FF3B30] transition-all hover:-translate-y-1"
            >
              <span className="font-heading text-4xl text-[#262626] group-hover:text-[#FF3B30] transition-colors">
                {step.number}
              </span>
              <h3 className="font-heading text-xl uppercase tracking-wider text-white mt-4 mb-3">
                {step.title}
              </h3>
              <p className="text-xs text-[#A3A3A3] font-body leading-relaxed">
                {step.desc}
              </p>
            </div>
          ))}
        </div>

        {/* What We Look For */}
        <div className="bg-[#0A0A0A] border border-[#262626] p-8" data-testid="admissions-criteria">
          <div className="flex items-center gap-3 mb-6">
            <Target className="w-5 h-5 text-[#FF3B30]" />
            <h3 className="font-heading text-lg uppercase tracking-wider text-white">
              {t.admissions.whatWeLook}
            </h3>
          </div>
          <ul className="space-y-4">
            {t.admissions.criteria.map((item, i) => (
              <li key={`criteria-${i}`} className="flex items-start gap-3">
                <ChevronRight className="w-4 h-4 text-[#FF3B30] shrink-0 mt-0.5" />
                <span className="text-sm text-[#A3A3A3] font-body leading-relaxed">
                  {item}
                </span>
              </li>
            ))}
          </ul>
        </div>

        {/* CTA */}
        <button
          data-testid="admissions-apply-btn"
          onClick={() => scrollTo("forms")}
          className="mt-10 bg-[#FF3B30] text-white font-heading uppercase tracking-widest px-8 py-4 text-sm hover:bg-[#FF5C53] transition-all hover:-translate-y-0.5"
        >
          {t.admissions.cta}
        </button>
      </div>
    </section>
  );
}
